import { CompanyResponseDto } from '@planning/app/api'
import companyService from '@planning/services/companyService'
import { AutocompleteViewStore } from '../autocomplete/AutocompleteViewStore'

export class CustomerAutocompleteViewStore extends AutocompleteViewStore<CompanyResponseDto> {
  constructor() {
    super(() => companyService.getByPartialName(this.filter))
  }
}
